import IdentityView from "../views/IdentityView.vue";
import SelfieForm from "@/components/forms/Identity/SelfieForm.vue";
import IdentityConfirmationForm from "@/components/forms/Identity/IdentityConfirmationForm.vue";
import PurposeOfTransactionForm from "@/components/forms/Identity/PurposeOfTransactionForm.vue";
import SourceOfFundsForm from "@/components/forms/Identity/SourceOfFundsForm.vue";
import PepSourceOfFundsForm from "@/components/forms/Identity/PepSourceOfFundsForm.vue";
import ProofOfAddressForm from "@/components/forms/Identity/ProofOfAddressForm.vue";
import SumsubForm from "@/components/forms/Identity/SumsubForm.vue";
import SofDocumentUploadForm from "@/components/forms/Identity/SofDocumentUploadForm.vue";
import OccupationForm from "@/components/forms/Identity/OccupationForm.vue";
import USTaxIDForm from "@/components/forms/USTaxIDForm.vue";
import DlocalIdentityForm from "@/components/forms/Identity/DlocalIdentityForm.vue";
import useProgressBarActions from "@/composables/progress/useProgressBarActions";
import DocumentNumberForm from "@/components/forms/Identity/DocumentNumberForm.vue";

const { updateToComplete } = useProgressBarActions();

const routes = [
  // todo: remove this
  {
    path: "/identity",
    name: "identity",
    component: IdentityView,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/:id",
    name: "identity.upload",
    component: IdentityView,
  },
  {
    path: "/identity/identityConfirmation",
    name: "identity.identityConfirmation",
    component: IdentityConfirmationForm,
    beforeEnter() {
      updateToComplete(["verification"]);
    },
  },
  {
    path: "/identity/selfie",
    name: "identity.selfie",
    component: SelfieForm,
  },
  {
    path: "/identity/purposeOfTransaction",
    name: "identity.purposeOfTransaction",
    component: PurposeOfTransactionForm,
  },
  {
    path: "/identity/sourceOfFunds",
    name: "identity.sourceOfFunds",
    component: SourceOfFundsForm,
  },
  {
    path: "/identity/pepSourceOfFunds",
    name: "identity.pepSourceOfFunds",
    component: PepSourceOfFundsForm,
  },
  {
    path: "/identity/sofDocumentUpload",
    name: "identity.sofDocumentUpload",
    component: SofDocumentUploadForm,
  },
  {
    path: "/identity/proofOfAddress",
    name: "identity.proofOfAddress",
    component: ProofOfAddressForm,
  },
  {
    path: "/identity/occupation",
    name: "identity.occupation",
    component: OccupationForm,
  },
  {
    path: "/identity/sumsub",
    name: "identity.sumsub",
    component: SumsubForm,
  },
  {
    path: "/identity/ssn",
    name: "identity.ssn",
    component: USTaxIDForm,
  },
  {
    path: "/identity/dlocal/:type",
    name: "identity.dlocal",
    component: DlocalIdentityForm,
  },
  {
    path: "/identity/document-number",
    name: "identity.document-number",
    component: DocumentNumberForm,
  },
];

export default routes;
